export const checkInRoutes = [
  {
    path: "/event/check-in",
    name: "EventSelection",
    component: () => import("@/views/event/checkin/EventSelection.vue"),
    meta: {
      title: "Event Selection - DSAG Event Check-in",
      permissions: ["event.showApplications"]
    }
  },
  {
    path: "/event/:routeSlug/check-in/qrcode",
    name: "QrCodeScan",
    component: () => import("@/views/event/checkin/QrCodeScan.vue"),
    meta: {
      title: "QR Code Scan - DSAG Event Check-in",
      permissions: ["event.showApplications"]
    }
  },
  {
    path: "/event/:routeSlug/check-in/manual",
    name: "ManualCheckIn",
    component: () => import("@/views/event/checkin/ManualCheckIn.vue"),
    meta: {
      title: "Manual CheckIn - DSAG Event Check-in",
      permissions: ["event.showApplications"]
    }
  }
];